import { supabase } from '../supabase';

export async function increaseCouponCountIfAny(taskId: number) {
  try {
    // Get task's coupon info
    const { data: task, error: taskError } = await supabase
      .from('tasks')
      .select('coupon_id')
      .eq('id', taskId)
      .single();

    if (taskError) throw taskError;

    // If task has a coupon, increment its usage
    if (task?.coupon_id) {
      const { data, error: updateError } = await supabase.rpc('increment_coupon_uses', { 
        coupon_id: task.coupon_id 
      });

      console.log('Update response:', { data, error: updateError });

      if (updateError) throw updateError;
    }
  } catch (error) {
    console.error('Error increasing coupon count:', error);
  }
} 

export interface Coupon {
  code: string;
  discount_amount: string;
  is_percentage: boolean;
  max_uses: string;
  expires_at: string;
  is_active: boolean;
}

export const createCoupons = (formData: Coupon) => {
  return supabase
  .from('coupons')
  .insert([{
    ...formData,
    code: formData.code.toUpperCase(),
    discount_amount: Number(formData.discount_amount),
    max_uses: formData.max_uses ? Number(formData.max_uses) : null,
    current_uses: 0
  }]);
}

export const fetchAllCoupons = () => {
  return supabase
      .from('coupons')
      .select('*')
      .order('created_at', { ascending: false });
}
export const updateCoupon = (couponId: number, newValue: boolean) => {
return supabase
.from('coupons')
.update({ is_active: newValue })
.eq('id', couponId);
}